module.exports = __webpack_public_path__ + "media/images/pc/specials/common/benefit/benefit_accessary-03574074ad60246f83873f37a57c556c.jpg";